import { render, staticRenderFns } from "./ResourceSingle.vue?vue&type=template&id=8bc1ff3e&scoped=true&"
import script from "./ResourceSingle.vue?vue&type=script&lang=ts&"
export * from "./ResourceSingle.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceSingle.vue?vue&type=style&index=0&id=8bc1ff3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc1ff3e",
  null
  
)

export default component.exports